export const DEFAULT_TICKET_ELEMENTS_ORDER = [
  "newTicket",
  "open",
  "pending",
  "group",
  "closed",
  "taskAgendamento",
  "taskEmail",
  "taskChatInterno",
  "taskAsaasFinancial",
  "taskAgendaCare",
  "taskOdontoCare",
  "taskCallcenter",
  "taskBarbearia",
  "taskCaixaPdv",
  "taskComidaNaPorta",
  "taskMotoqueiro",
  "taskErpPhone",
  "search",
  "contacts",
  "kanban",
  "queues"
];

export const DEFAULT_TICKET_TASKS_ENABLED = {
  agendamento: true,
  email: true,
  chatInterno: true,
  asaasFinancial: true,
  flowApp: true,
  linkWallet: true,
  agendacare: true,
  odontocare: true,
  callcenter: true,
  barbearia: true,
  caixaPdv: true,
  comidaNaPorta: true,
  motoqueiro: true,
  erpPhone: true
};

export const DEFAULT_TICKET_SIDEBAR_VISIBILITY = {
  newTicket: true,
  open: true,
  pending: true,
  group: true,
  closed: true,
  taskAgendamento: true,
  taskEmail: true,
  taskChatInterno: true,
  taskAsaasFinancial: true,
  taskAgendaCare: true,
  taskOdontoCare: true,
  taskCallcenter: true,
  taskBarbearia: true,
  taskCaixaPdv: true,
  taskComidaNaPorta: true,
  taskMotoqueiro: true,
  taskErpPhone: true,
  search: true,
  contacts: true,
  kanban: true,
  queues: true
};

export const DEFAULT_TICKET_LIST_FIELDS_ORDER = [
  "lastMessage",
  "date",
  "pin",
  "lastInteraction",
  "transfer",
  "delete",
  "kanbanStage",
  "attendant",
  "priority",
  "queue",
  "participants"
];

export const DEFAULT_TICKET_LIST_FIELDS_VISIBILITY = {
  lastMessage: true,
  date: true,
  pin: true,
  lastInteraction: true,
  transfer: true,
  delete: true,
  kanbanStage: true,
  attendant: true,
  priority: true,
  queue: true,
  participants: true
};

export const DEFAULT_TICKET_CONTROLS_VISIBILITY = {
  showAll: true,
  filters: true,
  sort: true,
  trafficFilter: true,
  priorityFilter: true,
  closeAll: true,
  withoutInteraction: true,
  queueFilter: true,
  tagsFilter: true,
  search: true,
};

export const TICKET_CONTROL_LABELS = {
  showAll: "Mostrar Todos / Meus Tickets",
  filters: "Filtros Avançados",
  sort: "Ordenação (Recentes / Antigos)",
  trafficFilter: "Filtro de Farol / Cores",
  priorityFilter: "Filtro de Prioridade",
  closeAll: "Fechar Todos os Tickets",
  withoutInteraction: "Filtro Sem Atendimento",
  queueFilter: "Filtro por Filas",
  tagsFilter: "Filtro por Tags",
  search: "Campo de Pesquisa",
};

export const DEFAULT_OPEN_TICKET_HEADER_ORDER = [
  "contactIndicators",
  "tags",
  "kanbanStage",
  "contactVisibility",
  "priority",
  "attachments",
  "ticketNotes",
  "ticketParticipants",
  "flowApp",
  "contactInfo",
  "linkWallet",
  "aiAgent",
  "delivery",
  "agendamento",
  "email",
  "chatInterno",
  "asaasFinancial",
  "accept",
  "reopen",
  "resolve",
  "returnQueue",
  "transfer",
  "call",
  "pdv",
  "menu",
  "signMessage"
];

export const DEFAULT_OPEN_TICKET_HEADER_VISIBILITY = {
  contactIndicators: true,
  tags: true,
  kanbanStage: true,
  contactVisibility: true,
  priority: true,
  attachments: true,
  ticketNotes: true,
  ticketParticipants: true,
  flowApp: true,
  contactInfo: true,
  linkWallet: true,
  aiAgent: true,
  delivery: true,
  agendamento: true,
  email: true,
  chatInterno: true,
  asaasFinancial: true,
  accept: true,
  reopen: true,
  resolve: true,
  returnQueue: true,
  transfer: true,
  call: true,
  pdv: true,
  menu: true,
  signMessage: true
};

export const TICKET_ORDER_TASK_DEPENDENCY = {
  taskAgendamento: "agendamento",
  taskEmail: "email",
  taskChatInterno: "chatInterno",
  taskAsaasFinancial: "asaasFinancial",
  taskAgendaCare: "agendacare",
  taskOdontoCare: "odontocare",
  taskCallcenter: "callcenter",
  taskBarbearia: "barbearia",
  taskCaixaPdv: "caixaPdv",
  taskComidaNaPorta: "comidaNaPorta",
  taskMotoqueiro: "motoqueiro",
  taskErpPhone: "erpPhone"
};

export const DEFAULT_TICKET_HIDE_INPUT_ON_SPY = false;
export const DEFAULT_TICKET_DEBIT_NOTICE_MODE = "show_value";

export const DEFAULT_LAST_MESSAGE_SENDER_BG = "rgba(14, 165, 233, 0.12)";
export const DEFAULT_LAST_MESSAGE_SENDER_COLOR = "#0ea5e9";
export const DEFAULT_LAST_MESSAGE_BODY_BG = "transparent";
export const DEFAULT_LAST_MESSAGE_BODY_COLOR = "inherit";

export const DEFAULT_ATTENDANT_LABEL_BG = "rgba(14, 165, 233, 0.12)";
export const DEFAULT_ATTENDANT_LABEL_COLOR = "#0ea5e9";
export const DEFAULT_ATTENDANT_NAME_BG = "rgba(148, 163, 184, 0.08)";
export const DEFAULT_ATTENDANT_NAME_COLOR = "inherit";
export const DEFAULT_METADATA_LABEL_BG = "rgba(148, 163, 184, 0.15)";
export const DEFAULT_METADATA_LABEL_COLOR = "inherit";
export const DEFAULT_METADATA_VALUE_BG = "rgba(148, 163, 184, 0.06)";
export const DEFAULT_METADATA_VALUE_COLOR = "inherit";
export const DEFAULT_LAST_INTERACTION_BG = "rgba(148, 163, 184, 0.1)";
export const DEFAULT_LAST_INTERACTION_COLOR = "inherit";

export const DEFAULT_CHAT_BODY_BG = "#f0f2f5";
export const DEFAULT_CHAT_BODY_BG_TYPE = "default";
export const DEFAULT_CHAT_BODY_BG_IMAGE = "";
export const DEFAULT_CHAT_BODY_BG_REPEAT = "cover";
export const DEFAULT_CHAT_BODY_BG_OPACITY = 1;
export const DEFAULT_CHAT_HEADER_BG = "#ffffff";
export const DEFAULT_CHAT_HEADER_COLOR = "#0f172a";
export const DEFAULT_INCOMING_BUBBLE_BG = "#ffffff";
export const DEFAULT_INCOMING_BUBBLE_COLOR = "#0f172a";
export const DEFAULT_OUTGOING_BUBBLE_BG = "#0284c7";
export const DEFAULT_OUTGOING_BUBBLE_COLOR = "#ffffff";
export const DEFAULT_MESSAGE_INPUT_BG = "#ffffff";
export const DEFAULT_MESSAGE_INPUT_TEXT_COLOR = "#0f172a";

export const DEFAULT_ACCEPT_MODAL_CONFIG = {
  enabled: true,
  showTag: true,
  showKanban: true,
  showContactType: true,
};

export const resolveAcceptModalConfig = (rawSetting) => {
  if (!rawSetting) return { ...DEFAULT_ACCEPT_MODAL_CONFIG };
  try {
    const parsed =
      typeof rawSetting === "string" ? JSON.parse(rawSetting) : rawSetting;
    const target = parsed?.acceptModalConfig || parsed;
    return {
      enabled:
        target?.enabled !== undefined
          ? Boolean(target.enabled)
          : DEFAULT_ACCEPT_MODAL_CONFIG.enabled,
      showTag:
        target?.showTag !== undefined
          ? Boolean(target.showTag)
          : DEFAULT_ACCEPT_MODAL_CONFIG.showTag,
      showKanban:
        target?.showKanban !== undefined
          ? Boolean(target.showKanban)
          : DEFAULT_ACCEPT_MODAL_CONFIG.showKanban,
      showContactType:
        target?.showContactType !== undefined
          ? Boolean(target.showContactType)
          : DEFAULT_ACCEPT_MODAL_CONFIG.showContactType,
    };
  } catch (e) {
    return { ...DEFAULT_ACCEPT_MODAL_CONFIG };
  }
};

// Ações do menu "Mais opções" que podem ser promovidas para a barra da mensagem.
// Por padrão a barra permanece como está; cada empresa escolhe os atalhos desejados.
export const DEFAULT_MESSAGE_INPUT_ACTIONS = [];
export const AVAILABLE_MESSAGE_INPUT_ACTIONS = [
  "contactInfo",
  "aiAgent",
  "delivery",
  "agendamento",
  "email",
  "chatInterno",
  "asaasFinancial",
  "call",
  "pdv",
  "export",
  "log",
  "integration",
  "acceptAudioMessage"
];

export const buildDefaultTicketLayoutConfig = () => ({
  elementsOrder: [...DEFAULT_TICKET_ELEMENTS_ORDER],
  tasksEnabled: { ...DEFAULT_TICKET_TASKS_ENABLED },
  sidebarVisibility: { ...DEFAULT_TICKET_SIDEBAR_VISIBILITY },
  controlsVisibility: { ...DEFAULT_TICKET_CONTROLS_VISIBILITY },
  listFieldsOrder: [...DEFAULT_TICKET_LIST_FIELDS_ORDER],
  listFieldsVisibility: { ...DEFAULT_TICKET_LIST_FIELDS_VISIBILITY },
  openTicketHeaderOrder: [...DEFAULT_OPEN_TICKET_HEADER_ORDER],
  openTicketHeaderVisibility: { ...DEFAULT_OPEN_TICKET_HEADER_VISIBILITY },
  messageInputActions: [...DEFAULT_MESSAGE_INPUT_ACTIONS],
  hideMessageInputOnSpy: DEFAULT_TICKET_HIDE_INPUT_ON_SPY,
  debitNoticeMode: DEFAULT_TICKET_DEBIT_NOTICE_MODE,
  acceptModalConfig: { ...DEFAULT_ACCEPT_MODAL_CONFIG },
  lastMessageSenderBg: DEFAULT_LAST_MESSAGE_SENDER_BG,
  lastMessageSenderColor: DEFAULT_LAST_MESSAGE_SENDER_COLOR,
  lastMessageBodyBg: DEFAULT_LAST_MESSAGE_BODY_BG,
  lastMessageBodyColor: DEFAULT_LAST_MESSAGE_BODY_COLOR,
  attendantLabelBg: DEFAULT_ATTENDANT_LABEL_BG,
  attendantLabelColor: DEFAULT_ATTENDANT_LABEL_COLOR,
  attendantNameBg: DEFAULT_ATTENDANT_NAME_BG,
  attendantNameColor: DEFAULT_ATTENDANT_NAME_COLOR,
  metadataLabelBg: DEFAULT_METADATA_LABEL_BG,
  metadataLabelColor: DEFAULT_METADATA_LABEL_COLOR,
  metadataValueBg: DEFAULT_METADATA_VALUE_BG,
  metadataValueColor: DEFAULT_METADATA_VALUE_COLOR,
  lastInteractionBg: DEFAULT_LAST_INTERACTION_BG,
  lastInteractionColor: DEFAULT_LAST_INTERACTION_COLOR,
  chatBodyBg: DEFAULT_CHAT_BODY_BG,
  chatBodyBgType: DEFAULT_CHAT_BODY_BG_TYPE,
  chatBodyBgImage: DEFAULT_CHAT_BODY_BG_IMAGE,
  chatBodyBgRepeat: DEFAULT_CHAT_BODY_BG_REPEAT,
  chatBodyBgOpacity: DEFAULT_CHAT_BODY_BG_OPACITY,
  chatHeaderBg: DEFAULT_CHAT_HEADER_BG,
  chatHeaderColor: DEFAULT_CHAT_HEADER_COLOR,
  incomingBubbleBg: DEFAULT_INCOMING_BUBBLE_BG,
  incomingBubbleColor: DEFAULT_INCOMING_BUBBLE_COLOR,
  outgoingBubbleBg: DEFAULT_OUTGOING_BUBBLE_BG,
  outgoingBubbleColor: DEFAULT_OUTGOING_BUBBLE_COLOR,
  messageInputBg: DEFAULT_MESSAGE_INPUT_BG,
  messageInputTextColor: DEFAULT_MESSAGE_INPUT_TEXT_COLOR,
});

export const parseTicketLayoutConfig = (rawValue) => {
  if (!rawValue || typeof rawValue !== "string") {
    return buildDefaultTicketLayoutConfig();
  }

  try {
    const parsed = JSON.parse(rawValue);
    const parsedOrder = Array.isArray(parsed?.elementsOrder)
      ? parsed.elementsOrder.filter((item) => DEFAULT_TICKET_ELEMENTS_ORDER.includes(item))
      : [];

    const dedupedOrder = [];
    for (const item of parsedOrder) {
      if (!dedupedOrder.includes(item)) {
        dedupedOrder.push(item);
      }
    }
    for (const item of DEFAULT_TICKET_ELEMENTS_ORDER) {
      if (!dedupedOrder.includes(item)) {
        dedupedOrder.push(item);
      }
    }

    const nextTasks = { ...DEFAULT_TICKET_TASKS_ENABLED };
    for (const key of Object.keys(DEFAULT_TICKET_TASKS_ENABLED)) {
      if (typeof parsed?.tasksEnabled?.[key] === "boolean") {
        nextTasks[key] = parsed.tasksEnabled[key];
      }
    }

    const nextSidebarVisibility = { ...DEFAULT_TICKET_SIDEBAR_VISIBILITY };
    for (const key of Object.keys(DEFAULT_TICKET_SIDEBAR_VISIBILITY)) {
      if (typeof parsed?.sidebarVisibility?.[key] === "boolean") {
        nextSidebarVisibility[key] = parsed.sidebarVisibility[key];
      }
    }

    const parsedListOrder = Array.isArray(parsed?.listFieldsOrder)
      ? parsed.listFieldsOrder.filter((item) =>
          DEFAULT_TICKET_LIST_FIELDS_ORDER.includes(item)
        )
      : [];
    const dedupedListOrder = [];
    for (const item of parsedListOrder) {
      if (!dedupedListOrder.includes(item)) {
        dedupedListOrder.push(item);
      }
    }
    for (const item of DEFAULT_TICKET_LIST_FIELDS_ORDER) {
      if (!dedupedListOrder.includes(item)) {
        dedupedListOrder.push(item);
      }
    }

    const nextListVisibility = { ...DEFAULT_TICKET_LIST_FIELDS_VISIBILITY };
    for (const key of Object.keys(DEFAULT_TICKET_LIST_FIELDS_VISIBILITY)) {
      if (typeof parsed?.listFieldsVisibility?.[key] === "boolean") {
        nextListVisibility[key] = parsed.listFieldsVisibility[key];
      }
    }

    const nextControlsVisibility = { ...DEFAULT_TICKET_CONTROLS_VISIBILITY };
    for (const key of Object.keys(DEFAULT_TICKET_CONTROLS_VISIBILITY)) {
      if (typeof parsed?.controlsVisibility?.[key] === "boolean") {
        nextControlsVisibility[key] = parsed.controlsVisibility[key];
      }
    }

    const parsedOpenHeaderOrder = Array.isArray(parsed?.openTicketHeaderOrder)
      ? parsed.openTicketHeaderOrder.filter((item) =>
          DEFAULT_OPEN_TICKET_HEADER_ORDER.includes(item)
        )
      : [];
    const dedupedOpenHeaderOrder = [];
    for (const item of parsedOpenHeaderOrder) {
      if (!dedupedOpenHeaderOrder.includes(item)) {
        dedupedOpenHeaderOrder.push(item);
      }
    }
    for (const item of DEFAULT_OPEN_TICKET_HEADER_ORDER) {
      if (!dedupedOpenHeaderOrder.includes(item)) {
        dedupedOpenHeaderOrder.push(item);
      }
    }

    // Se attachments, ticketNotes ou ticketParticipants não estavam na configuração salva anterior, insere logo após priority
    if (!parsedOpenHeaderOrder.includes("attachments")) {
      const pIdx = dedupedOpenHeaderOrder.indexOf("priority");
      const curIdx = dedupedOpenHeaderOrder.indexOf("attachments");
      if (curIdx >= 0 && pIdx >= 0 && curIdx > pIdx) {
        dedupedOpenHeaderOrder.splice(curIdx, 1);
        dedupedOpenHeaderOrder.splice(pIdx + 1, 0, "attachments");
      }
    }
    if (!parsedOpenHeaderOrder.includes("ticketNotes")) {
      const aIdx = dedupedOpenHeaderOrder.indexOf("attachments");
      const curIdx = dedupedOpenHeaderOrder.indexOf("ticketNotes");
      if (curIdx >= 0 && aIdx >= 0 && curIdx > aIdx) {
        dedupedOpenHeaderOrder.splice(curIdx, 1);
        dedupedOpenHeaderOrder.splice(aIdx + 1, 0, "ticketNotes");
      }
    }
    if (!parsedOpenHeaderOrder.includes("ticketParticipants")) {
      const nIdx = dedupedOpenHeaderOrder.indexOf("ticketNotes");
      const curIdx = dedupedOpenHeaderOrder.indexOf("ticketParticipants");
      if (curIdx >= 0 && nIdx >= 0 && curIdx > nIdx) {
        dedupedOpenHeaderOrder.splice(curIdx, 1);
        dedupedOpenHeaderOrder.splice(nIdx + 1, 0, "ticketParticipants");
      }
    }

    const nextOpenHeaderVisibility = { ...DEFAULT_OPEN_TICKET_HEADER_VISIBILITY };
    for (const key of Object.keys(DEFAULT_OPEN_TICKET_HEADER_VISIBILITY)) {
      if (typeof parsed?.openTicketHeaderVisibility?.[key] === "boolean") {
        nextOpenHeaderVisibility[key] = parsed.openTicketHeaderVisibility[key];
      }
    }

    // Configurações anteriores agrupavam nome e indicadores no mesmo controle.
    // Mantemos a intenção de ocultar os indicadores, mas o nome passa a ficar visível.
    if (
      typeof parsed?.openTicketHeaderVisibility?.contactIndicators !== "boolean" &&
      typeof parsed?.openTicketHeaderVisibility?.contactName === "boolean"
    ) {
      nextOpenHeaderVisibility.contactIndicators =
        parsed.openTicketHeaderVisibility.contactName;
    }

    const hideMessageInputOnSpy =
      typeof parsed?.hideMessageInputOnSpy === "boolean"
        ? parsed.hideMessageInputOnSpy
        : parsed?.ticketHideInputOnSpy === "enabled" || parsed?.ticketHideInputOnSpy === true;

    const debitNoticeMode =
      typeof parsed?.debitNoticeMode === "string" &&
      ["show_value", "hide_value", "disabled"].includes(parsed.debitNoticeMode)
        ? parsed.debitNoticeMode
        : typeof parsed?.ticketDebitNoticeMode === "string" &&
          ["show_value", "hide_value", "disabled"].includes(parsed.ticketDebitNoticeMode)
        ? parsed.ticketDebitNoticeMode
        : DEFAULT_TICKET_DEBIT_NOTICE_MODE;

    const rawAcceptModal = parsed?.acceptModalConfig;
    const acceptModalConfig = {
      enabled:
        rawAcceptModal?.enabled !== undefined
          ? Boolean(rawAcceptModal.enabled)
          : DEFAULT_ACCEPT_MODAL_CONFIG.enabled,
      showTag:
        rawAcceptModal?.showTag !== undefined
          ? Boolean(rawAcceptModal.showTag)
          : DEFAULT_ACCEPT_MODAL_CONFIG.showTag,
      showKanban:
        rawAcceptModal?.showKanban !== undefined
          ? Boolean(rawAcceptModal.showKanban)
          : DEFAULT_ACCEPT_MODAL_CONFIG.showKanban,
      showContactType:
        rawAcceptModal?.showContactType !== undefined
          ? Boolean(rawAcceptModal.showContactType)
          : DEFAULT_ACCEPT_MODAL_CONFIG.showContactType,
    };

    const messageInputActions = Array.isArray(parsed?.messageInputActions)
      ? [...new Set(parsed.messageInputActions.filter((item) =>
          AVAILABLE_MESSAGE_INPUT_ACTIONS.includes(item)
        ))]
      : [...DEFAULT_MESSAGE_INPUT_ACTIONS];

    const lastMessageSenderBg =
      typeof parsed?.lastMessageSenderBg === "string" && parsed.lastMessageSenderBg.trim()
        ? parsed.lastMessageSenderBg.trim()
        : DEFAULT_LAST_MESSAGE_SENDER_BG;

    const lastMessageSenderColor =
      typeof parsed?.lastMessageSenderColor === "string" && parsed.lastMessageSenderColor.trim()
        ? parsed.lastMessageSenderColor.trim()
        : DEFAULT_LAST_MESSAGE_SENDER_COLOR;

    const lastMessageBodyBg =
      typeof parsed?.lastMessageBodyBg === "string" && parsed.lastMessageBodyBg.trim()
        ? parsed.lastMessageBodyBg.trim()
        : DEFAULT_LAST_MESSAGE_BODY_BG;

    const lastMessageBodyColor =
      typeof parsed?.lastMessageBodyColor === "string" && parsed.lastMessageBodyColor.trim()
        ? parsed.lastMessageBodyColor.trim()
        : DEFAULT_LAST_MESSAGE_BODY_COLOR;

    const attendantLabelBg =
      typeof parsed?.attendantLabelBg === "string" && parsed.attendantLabelBg.trim()
        ? parsed.attendantLabelBg.trim()
        : DEFAULT_ATTENDANT_LABEL_BG;

    const attendantLabelColor =
      typeof parsed?.attendantLabelColor === "string" && parsed.attendantLabelColor.trim()
        ? parsed.attendantLabelColor.trim()
        : DEFAULT_ATTENDANT_LABEL_COLOR;

    const attendantNameBg =
      typeof parsed?.attendantNameBg === "string" && parsed.attendantNameBg.trim()
        ? parsed.attendantNameBg.trim()
        : DEFAULT_ATTENDANT_NAME_BG;

    const attendantNameColor =
      typeof parsed?.attendantNameColor === "string" && parsed.attendantNameColor.trim()
        ? parsed.attendantNameColor.trim()
        : DEFAULT_ATTENDANT_NAME_COLOR;

    const metadataLabelBg =
      typeof parsed?.metadataLabelBg === "string" && parsed.metadataLabelBg.trim()
        ? parsed.metadataLabelBg.trim()
        : DEFAULT_METADATA_LABEL_BG;

    const metadataLabelColor =
      typeof parsed?.metadataLabelColor === "string" && parsed.metadataLabelColor.trim()
        ? parsed.metadataLabelColor.trim()
        : DEFAULT_METADATA_LABEL_COLOR;

    const metadataValueBg =
      typeof parsed?.metadataValueBg === "string" && parsed.metadataValueBg.trim()
        ? parsed.metadataValueBg.trim()
        : DEFAULT_METADATA_VALUE_BG;

    const metadataValueColor =
      typeof parsed?.metadataValueColor === "string" && parsed.metadataValueColor.trim()
        ? parsed.metadataValueColor.trim()
        : DEFAULT_METADATA_VALUE_COLOR;

    const lastInteractionBg =
      typeof parsed?.lastInteractionBg === "string" && parsed.lastInteractionBg.trim()
        ? parsed.lastInteractionBg.trim()
        : DEFAULT_LAST_INTERACTION_BG;

    const lastInteractionColor =
      typeof parsed?.lastInteractionColor === "string" && parsed.lastInteractionColor.trim()
        ? parsed.lastInteractionColor.trim()
        : DEFAULT_LAST_INTERACTION_COLOR;

    const chatBodyBg =
      typeof parsed?.chatBodyBg === "string" && parsed.chatBodyBg.trim()
        ? parsed.chatBodyBg.trim()
        : DEFAULT_CHAT_BODY_BG;

    const chatBodyBgType =
      typeof parsed?.chatBodyBgType === "string" && parsed.chatBodyBgType.trim()
        ? parsed.chatBodyBgType.trim()
        : DEFAULT_CHAT_BODY_BG_TYPE;

    const chatBodyBgImage =
      typeof parsed?.chatBodyBgImage === "string"
        ? parsed.chatBodyBgImage.trim()
        : DEFAULT_CHAT_BODY_BG_IMAGE;

    const chatBodyBgRepeat =
      typeof parsed?.chatBodyBgRepeat === "string" && parsed.chatBodyBgRepeat.trim()
        ? parsed.chatBodyBgRepeat.trim()
        : DEFAULT_CHAT_BODY_BG_REPEAT;

    const chatBodyBgOpacity =
      typeof parsed?.chatBodyBgOpacity === "number" && !isNaN(parsed.chatBodyBgOpacity)
        ? parsed.chatBodyBgOpacity
        : DEFAULT_CHAT_BODY_BG_OPACITY;

    const chatHeaderBg =
      typeof parsed?.chatHeaderBg === "string" && parsed.chatHeaderBg.trim()
        ? parsed.chatHeaderBg.trim()
        : DEFAULT_CHAT_HEADER_BG;

    const chatHeaderColor =
      typeof parsed?.chatHeaderColor === "string" && parsed.chatHeaderColor.trim()
        ? parsed.chatHeaderColor.trim()
        : DEFAULT_CHAT_HEADER_COLOR;

    const incomingBubbleBg =
      typeof parsed?.incomingBubbleBg === "string" && parsed.incomingBubbleBg.trim()
        ? parsed.incomingBubbleBg.trim()
        : DEFAULT_INCOMING_BUBBLE_BG;

    const incomingBubbleColor =
      typeof parsed?.incomingBubbleColor === "string" && parsed.incomingBubbleColor.trim()
        ? parsed.incomingBubbleColor.trim()
        : DEFAULT_INCOMING_BUBBLE_COLOR;

    const outgoingBubbleBg =
      typeof parsed?.outgoingBubbleBg === "string" && parsed.outgoingBubbleBg.trim()
        ? parsed.outgoingBubbleBg.trim()
        : DEFAULT_OUTGOING_BUBBLE_BG;

    const outgoingBubbleColor =
      typeof parsed?.outgoingBubbleColor === "string" && parsed.outgoingBubbleColor.trim()
        ? parsed.outgoingBubbleColor.trim()
        : DEFAULT_OUTGOING_BUBBLE_COLOR;

    const messageInputBg =
      typeof parsed?.messageInputBg === "string" && parsed.messageInputBg.trim()
        ? parsed.messageInputBg.trim()
        : DEFAULT_MESSAGE_INPUT_BG;

    const messageInputTextColor =
      typeof parsed?.messageInputTextColor === "string" && parsed.messageInputTextColor.trim()
        ? parsed.messageInputTextColor.trim()
        : DEFAULT_MESSAGE_INPUT_TEXT_COLOR;

    return {
      elementsOrder: dedupedOrder,
      tasksEnabled: nextTasks,
      sidebarVisibility: nextSidebarVisibility,
      controlsVisibility: nextControlsVisibility,
      listFieldsOrder: dedupedListOrder,
      listFieldsVisibility: nextListVisibility,
      openTicketHeaderOrder: dedupedOpenHeaderOrder,
      openTicketHeaderVisibility: nextOpenHeaderVisibility,
      messageInputActions,
      hideMessageInputOnSpy: Boolean(hideMessageInputOnSpy),
      debitNoticeMode,
      acceptModalConfig,
      lastMessageSenderBg,
      lastMessageSenderColor,
      lastMessageBodyBg,
      lastMessageBodyColor,
      attendantLabelBg,
      attendantLabelColor,
      attendantNameBg,
      attendantNameColor,
      metadataLabelBg,
      metadataLabelColor,
      metadataValueBg,
      metadataValueColor,
      lastInteractionBg,
      lastInteractionColor,
      chatBodyBg,
      chatBodyBgType,
      chatBodyBgImage,
      chatBodyBgRepeat,
      chatBodyBgOpacity,
      chatHeaderBg,
      chatHeaderColor,
      incomingBubbleBg,
      incomingBubbleColor,
      outgoingBubbleBg,
      outgoingBubbleColor,
      messageInputBg,
      messageInputTextColor,
    };
  } catch (_error) {
    return buildDefaultTicketLayoutConfig();
  }
};

export const resolveChatBodyBackgroundStyle = (
  config,
  theme,
  customWaLight,
  customWaDark
) => {
  const bgType = config?.chatBodyBgType || DEFAULT_CHAT_BODY_BG_TYPE;
  const isDark = theme?.palette?.type === "dark" || theme?.mode === "dark";
  const bgColor = config?.chatBodyBg || (isDark ? "#0f172a" : "#f0f2f5");
  const repeat = config?.chatBodyBgRepeat || DEFAULT_CHAT_BODY_BG_REPEAT;
  const customImg = config?.chatBodyBgImage || "";

  let backgroundImage = undefined;
  let backgroundRepeat = repeat;
  let backgroundSize = "auto";
  let backgroundPosition = "center";

  if (bgType === "none") {
    backgroundImage = "none";
  } else if (
    bgType === "wa_light" ||
    (bgType === "default" && !isDark)
  ) {
    if (customWaLight) {
      backgroundImage = `url("${customWaLight}")`;
      backgroundRepeat = "repeat";
    }
  } else if (
    bgType === "wa_dark" ||
    (bgType === "default" && isDark)
  ) {
    if (customWaDark) {
      backgroundImage = `url("${customWaDark}")`;
      backgroundRepeat = "repeat";
    }
  } else if (bgType === "geometric") {
    backgroundImage = `url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%239ca3af' fill-opacity='0.16' fill-rule='evenodd'%3E%3Ccircle cx='3' cy='3' r='1.5'/%3E%3Ccircle cx='15' cy='15' r='1.5'/%3E%3C/g%3E%3C/svg%3E")`;
    backgroundRepeat = "repeat";
  } else if (bgType === "custom" && customImg) {
    backgroundImage = `url("${customImg}")`;
    if (repeat === "tile") {
      backgroundRepeat = "repeat";
      backgroundSize = "auto";
      backgroundPosition = "center center";
    } else if (repeat === "contain") {
      backgroundRepeat = "no-repeat";
      backgroundSize = "contain";
      backgroundPosition = "center center";
    } else if (repeat === "fit_width") {
      backgroundRepeat = "no-repeat";
      backgroundSize = "100% 100%";
      backgroundPosition = "center center";
    } else {
      // Padrão cover: de lado a lado cobrindo 100% da tela sem quebrar
      backgroundRepeat = "no-repeat";
      backgroundSize = "cover";
      backgroundPosition = "center center";
    }
  }

  const style = {
    backgroundColor: bgColor,
  };

  if (backgroundImage !== undefined) {
    style.backgroundImage = backgroundImage;
    style.backgroundRepeat = backgroundRepeat;
    style.backgroundSize = backgroundSize;
    style.backgroundPosition = backgroundPosition;
  }

  return style;
};

